import { shrpaApi } from "@/repos/axios";
import { getCalendarId } from "@logic/calendarManager";

export default class SocialIntegrationRepo {
  static async createPortalLink(customerId: string, returnUrl: string): Promise<string> {
    const calendarId = await getCalendarId(customerId);
    const url = `/social-account/manage/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/portal-link`;
    const { data } = await shrpaApi.post<string>(url, null, { params: { returnUrl } });
    return data;
  }

  static async getSocialAccounts(customerId: string): Promise<string> {
    const calendarId = await getCalendarId(customerId);
    const url = `/social-account/manage/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/social-accounts`;
    const { data } = await shrpaApi.get<string>(url);
    return data;
  }
}
